import styled from 'styled-components';

export const Container = styled.div`
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  background-color: #FFFFFF;
  padding-bottom: 80px;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

export const FacilityList = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FacilityCard = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.2s ease;
  }
`;

export const FacilityImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const FacilityOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const LeftInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
`;

export const RightInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const FacilitySubtitle = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #FFFFFF;
  opacity: 0.9;
`;

export const FacilityBuilding = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: #FFFFFF;
  opacity: 0.8;
`;

export const FacilityTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #FFFFFF;
`;
